import { render, staticRenderFns } from "./RatingStars.vue?vue&type=template&id=531e6d0c&scoped=true"
import script from "./RatingStars.vue?vue&type=script&lang=js"
export * from "./RatingStars.vue?vue&type=script&lang=js"
import style0 from "./RatingStars.vue?vue&type=style&index=0&id=531e6d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531e6d0c",
  null
  
)

export default component.exports